import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "./coursedetails.css";
import WorkingScormPlayer from "./WorkingScormPlayer";
import ProgressAPIService from "./ProgressAPIService";
import { useUserContext } from "../../common/UserProvider";
import FirstHtmlPage from "./FirstHtmlPage";
import AssignmentEditor from "./AssignmentEditor";
import { getAllAssignmentsByApplicant } from "./assignmentservice";



// ─── Static course data (outside component so it never re-creates) ───────────
// Course mapping to convert course names to actual course IDs
const getCourseId = (courseName) => {
  const courseMap = {
    "data analysis": 10,
    "nlp": 11,
    "deep learning": 12,
    "statistics": 13,
    "advanced nlp": 14,
    "html & css": 1,
    "python": 2,
    "java": 3,
    "springboot": 9,
    "interview preparedness": 7,
    "sql": 4,
    "javascript & es6": 5,
    "react": 6,
    "java exceptions and algorithms": 8,
    "machine learning": 15,
    "generative ai": 16,
  };
  return courseMap[courseName.toLowerCase()] || 0;
};

const markAsDoneAllowedCourses = [10, 11, 12, 13, 14, 15, 16];


const COURSE_DATA = {
  "html & css": [
    { topic: "Introduction to Web App", videos: [{ title: "What is a Web Application?", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/introductiontowebapp_topic1/story.html" }] },
    { topic: "HTML for Beginners", videos: [{ title: "Basics of HTML Structure", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/htmlforbegginers_topic2/story.html" }] },
    { topic: "CSS Part 1", videos: [{ title: "Introduction to CSS Styling", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/csspart1_topic3/story.html" }] },
    { topic: "CSS Part 2", videos: [{ title: "Advanced CSS Concepts", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/csspart2_topic4/story.html" }] },
    { topic: "HTML Forms", videos: [{ title: "Creating Forms in HTML", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/HTML%20FORMS_topic5/story.html" }] },
  ],
  "python": [
    { topic: "Introduction to python", videos: [{ title: "What is a python?", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Introduction+to+Python_topic1/story.html" }] },
    { topic: "Python variables and data types", videos: [{ title: "Variables and Data Types", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Variables+and+Data+Types_topic2/story.html" }] },
    { topic: "Python Operators", videos: [{ title: "Operators", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Operators_topic3/story.html" }] },
    { topic: "Python conditional statements", videos: [{ title: "Conditional Statements", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Conditional+Statements_topic4/story.html" }] },
    { topic: "Python Loops", videos: [{ title: "Loops", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Loop+Control+Statements_topic5/story.html" }] },
    { topic: "Python Data Structures Part 1", videos: [{ title: "Data Structures Part 1", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Data+Structures++Part+1_topic6/story.html" }] },
    { topic: "Python Data Structures Part 2", videos: [{ title: "Data Structures Part 2", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Data+Structures++Part+2_topic7/story.html" }] },
    { topic: "Python Data Structures Part 3", videos: [{ title: "Data Structures Part 3", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Data+Structures++Part+3_(Strings)_topic8/story.html" }] },
    { topic: "Python functions", videos: [{ title: "Functions", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Functions_topic9/story.html" }] },
    { topic: "Python modules", videos: [{ title: "Modules", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Modules_topic10/story.html" }] },
    { topic: "Python OOPS", videos: [{ title: "OOPS concepts", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Object+Oriented+Programming_topic11/story.html" }] },
    { topic: "Python Constructors", videos: [{ title: "Constructors", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Constructors_topic12/story.html" }] },
    { topic: "Python Inheritance", videos: [{ title: "Inheritance", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Python+Inheritance_topic13/story.html" }] },
  ],
  "java": [
    { topic: "Problem solving Fundamentals", videos: [{ title: "Problem solving Fundamentals", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/Topic+1+PROBLEM+SOLVING+FUNDAMENTALS+-+Copy/story.html" }] },
    { topic: "Introduction to java", videos: [{ title: "Introduction to java", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/INTRODUCTION+TO+JAVA/story.html" }] },
    { topic: "Data Types", videos: [{ title: "Data Types", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/Topic+3+DATA+TYPES/story.html" }] },
    { topic: "Control Statements", videos: [{ title: "Control Statements", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/CONTROL+STATEMENTS/story.html" }] },
    { topic: "Arrays", videos: [{ title: "Arrays", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/ARRAYS/story.html" }] },
    { topic: "Java Classes and Objects", videos: [{ title: "Java Classes and Objects", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/JAVA+CLASS+AND+OBJECTS/story.html" }] },
    { topic: "Java Classes Members", videos: [{ title: "Java Classes Members", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/JAVA+CLASS+MEMBERS/story.html" }] },
    { topic: "Strings", videos: [{ title: "Strings", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/STRINGS/story.html" }] },
    { topic: "OOPS - part1", videos: [{ title: "OOPS - part1", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/OOPS+-+PART1/story.html" }] },
    { topic: "OOPS - part2", videos: [{ title: "OOPS - part2", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/OOPS+–+PART2/story.html" }] },
    { topic: "Data Structures", videos: [{ title: "Data Structures", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/DATA+STRUCTURES/story.html" }] },
    { topic: "Collections in java - 1", videos: [{ title: "Collections in java - 1", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/COLLECTIONS+IN+JAVA+–+1/story.html" }] },
    { topic: "Collections in java - 2", videos: [{ title: "Collections in java - 2", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javabasics/COLLECTIONS+IN+JAVA_+-+2/story.html" }] },

  ],
  "springboot": [
    { topic: "Introduction to Hibernate", videos: [{ title: "Introduction to Hibernate", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Introduction+to+Hibernate/story.html" }] },
    { topic: "Hibernate Configuration", videos: [{ title: "Hibernate Configuration", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Hibernate+Configuration/story.html" }] },
    { topic: "Hibernate CRUD Operations", videos: [{ title: "Hibernate CRUD Operations", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Hibernate+CRUD+Operations/story.html" }] },
    { topic: "Hibernate Caching", videos: [{ title: "Hibernate Caching", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Hibernate+Caching/story.html" }] },
    { topic: "Hibernate Collection Mapping", videos: [{ title: "Hibernate Collection Mapping", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Hibernate+Collection+Mapping/story.html" }] },
    { topic: "Hibernate Association Mapping", videos: [{ title: "Hibernate Association Mapping", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Hibernate+Association+Mapping/story.html" }] },
    { topic: "Hibernate Query Language", videos: [{ title: "Hibernate Query Language", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Hibernate+Query+Language/story.html" }] },
    { topic: "JUnit Testing", videos: [{ title: "JUnit Testing", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/JUnit+Testing/story.html" }] },
    { topic: "Introduction to Spring Framework", videos: [{ title: "Introduction to Spring Framework", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Introduction+to+Spring+_Framework/story.html" }] },
    { topic: "Spring with Hibernate", videos: [{ title: "Spring with Hibernate", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Spring+with+Hibernate/story.html" }] },
    { topic: "Spring with Hibernate Integration", videos: [{ title: "Spring with Hibernate Integration", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Spring+with+Hibernate+Integration/story.html" }] },
    { topic: "Annotations in Spring MVC Framework", videos: [{ title: "Annotations in Spring MVC Framework", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Annotations+in+Spring+MVC+Framework/story.html" }] },
    { topic: "Introduction to Spring Boot", videos: [{ title: "Introduction to Spring Boot", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Introduction+to+Spring+Boot_/story.html" }] },
    { topic: "Introduction to Web Services", videos: [{ title: "Introduction to Web Services", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Introduction+to+Web+Services/story.html" }] },
    { topic: "CRUD Operations in Spring Boot Using REST API", videos: [{ title: "CRUD Operations in Spring Boot Using REST API", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/CRUD+Operations+in+Spring+Boot+Using+REST+API/story.html" }] },
    { topic: "Spring Security Part 1", videos: [{ title: "Spring Security Part 1", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Spring+Security+Part+1/story.html" }] },
    { topic: "Spring Security Part 2", videos: [{ title: "Spring Security Part 2", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Spring+Security+Part+2/story.html" }] },
    { topic: "Spring Boot with JSON Web Token (JWT)", videos: [{ title: "Spring Boot with JSON Web Token (JWT)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Spring+Boot+with+JSON+Web+Token+(JWT)%C2%A0/story.html" }] },
    { topic: "Introduction to Swagger", videos: [{ title: "Introduction to Swagger", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Introduction+to+Swagger/story.html" }] },
    { topic: "Git and GitHub", videos: [{ title: "Git and GitHub", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/springboot/Git+and+GitHub/story.html" }] },
  ],
  "javascript & es6": [

    { topic: "Introduction to Scalable Vector Graphics (SVG)", videos: [{ title: "Introduction to Scalable Vector Graphics (SVG)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Introduction+to+Scalable+Vector+Graphics+(SVG)/story.html" }] },
    { topic: "SVG - Shape Properties", videos: [{ title: "SVG - Shape Properties", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/SVG+-+Shape+Properties/story.html" }] },
    { topic: "Introduction to Responsive Web Designs", videos: [{ title: "Introduction to Responsive Web Designs", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Introduction+to+Responsive+Web+Designs/story.html" }] },
    { topic: "Introduction to Media Queries", videos: [{ title: "Introduction to Media Queries", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Introduction+to+Media+Queries/story.html" }] },
    { topic: "Implementation of Web Applications Using Media Queries", videos: [{ title: "Implementation of Web Applications Using Media Queries", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Implementation+of+Web+Applications+Using+Media+Queries/story.html" }] },
    { topic: "Introduction to JavaScript", videos: [{ title: "Introduction to JavaScript", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Introduction+to+JavaScript/story.html " }] },
    { topic: "JavaScript - Working with Data Types and Operators", videos: [{ title: "JavaScript - Working with Data Types and Operators", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/JavaScript+-+Working+with+Data+Types+and+Operators/story.html" }] },
    { topic: "JavaScript - Control Statements", videos: [{ title: "JavaScript - Control Statements", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/JavaScript+%E2%80%93+Control+Statements/story.html" }] },
    { topic: "JavaScript Validation & Regular Expressions", videos: [{ title: "JavaScript Validation & Regular Expressions", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/JavaScript+Validation++Regular+Expressions/story.html" }] },
    { topic: "JavaScript Events", videos: [{ title: "JavaScript Events", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/JavaScript+Events/story.html" }] },
    { topic: "Introduction to ECMAScript (ES6)", videos: [{ title: "Introduction to ECMAScript (ES6)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Introduction+to+ECMAScript+(ES6)/story.html" }] },
    { topic: "ECMAScript (ES6) - Functions", videos: [{ title: "ECMAScript (ES6) - Functions", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/ECMAScript(ES6)+-+Functions+(1)/story.html" }] },
    { topic: "Introduction to JavaScript Object Notation (JSON)", videos: [{ title: "Introduction to JavaScript Object Notation (JSON)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/Introduction+to+_JavaScript+Object+Notation(JSON)/story.html" }] },
    { topic: "JSON - Objects", videos: [{ title: "JSON - Objects", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/javascript/JSON+-+Objects/story.html" }] },

  ],

  "interview preparedness": [
    // ── Group 0: Understanding Yourself (3 subtopics) ──────────────────────
    { topic: "Understanding Yourself – Self Realization", groupName: "Understanding Yourself", groupIndex: 0, videos: [{ title: "Understanding Yourself – Self Realization", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Understanding+Yourself++Self+Realization/story.html" }] },
    { topic: "Confidence Building & Self-Motivation", groupName: "Understanding Yourself", groupIndex: 0, videos: [{ title: "Confidence Building & Self-Motivation", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Confidence+building+and+self-motivation/story.html" }] },
    { topic: "Overcoming Shyness, Fear & Anxiety", groupName: "Understanding Yourself", groupIndex: 0, videos: [{ title: "Overcoming Shyness, Fear & Anxiety", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Shyness%2C+Fear%2C+and+Anxiety+-+Ways+of+Control/story.html" }] },
    // ── Group 1: Introduction to Communication (4 subtopics) ───────────────
    { topic: "Components of Communication", groupName: "Introduction to Communication", groupIndex: 1, videos: [{ title: "Components of Communication", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Components+of+Communication/story.html" }] },
    { topic: "Communication Methods", groupName: "Introduction to Communication", groupIndex: 1, videos: [{ title: "Communication Methods", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Communication+Methods/story.html" }] },
    { topic: "Conveying Message Effectively – Part 1", groupName: "Introduction to Communication", groupIndex: 1, videos: [{ title: "Conveying Message Effectively – Part 1", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Conveying+Message+Effectively+-+Part+1/story.html" }] },
    { topic: "Conveying Message Effectively – Part 2", groupName: "Introduction to Communication", groupIndex: 1, videos: [{ title: "Conveying Message Effectively – Part 2", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Conveying+Message+Effectively+-+Part+2/story.html" }] },
    // ── Group 2: Self Introduction (3 subtopics) ──────────────────────────
    { topic: "Creating Self-Introduction", groupName: "Self Introduction", groupIndex: 2, videos: [{ title: "Creating Self-Introduction", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Creating+Self-introduction/story.html" }] },
    { topic: "Tips for Effective Introduction", groupName: "Self Introduction", groupIndex: 2, videos: [{ title: "Tips for Effective Introduction", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Tips+for+Effective+Introduction+in+Different+Scenarios/story.html" }] },
    { topic: "Creating Your First Impression", groupName: "Self Introduction", groupIndex: 2, videos: [{ title: "Creating Your First Impression", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Softskills+Foundation+-+Creating+your+First+Impression/story.html" }] },
  ],
  sql: [
    { topic: "Introduction to Structured Query Language(SQL)", videos: [{ title: "Introduction to Structured Query Language(SQL)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Introduction%20to%20Structured%20Query%20Language(SQL)/story.html" }] },
    { topic: "Data Definition Language (DDL)", videos: [{ title: "Data Definition Language (DDL)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Data%20Definition%20Language%20(DDL)/story.html" }] },
    { topic: "Data Manipulation Language (DML)", videos: [{ title: "Data Manipulation Language (DML)", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Data%20Manipulation%20Language%20(DML)/story.html" }] },
    { topic: "Constraints", videos: [{ title: "Constraints", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Constraints_/story.html" }] },
    { topic: "Normalization", videos: [{ title: "Normalization", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/Normalization/story.html" }] },
    { topic: "SQL Clauses", videos: [{ title: "SQL Clauses", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/SQL%20Clauses/story.html" }] },
    { topic: "SQL Functions", videos: [{ title: "SQL Functions", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/SQL%20Functions/story.html" }] },
    { topic: "SQL Joins and Views", videos: [{ title: "SQL Joins and Views", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/SQL%20Joins%20and%20Views/story.html" }] },
    { topic: "SQL Operators", videos: [{ title: "SQL Operators", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/SQL%20Operators/story.html" }] },
    { topic: "SQL Sub-queries", videos: [{ title: "SQL Sub-queries", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/SQL%20Sub-queries/story.html" }] },
    { topic: "TCL and DCL Commands", videos: [{ title: "TCL and DCL Commands", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/TCL%20and%20DCL%20Commands_/story.html" }] },
  ],
  "react": [
    { topic: "Introduction to ReactJS", videos: [{ title: "Introduction to ReactJS", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/Introduction+to+ReactJs/story.html" }] },
    { topic: "ReactJS – Environment Setup", videos: [{ title: "ReactJS – Environment Setup", url: " https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+-+Environment+Setup/story.html" }] },
    { topic: "ReactJS Components", videos: [{ title: "ReactJS Components", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Components/story.html" }] },
    { topic: "ReactJS Component Life Cycle", videos: [{ title: "ReactJS Component Life Cycle", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Component+Life+Cycle/story.html" }] },
    { topic: "ReactJS Hooks", videos: [{ title: "ReactJS Hooks", url: "  https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Hooks/story.html" }] },
    { topic: "ReactJS Forms and UI", videos: [{ title: "ReactJS Forms and UI", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Forms+and+UI/story.html" }] },
    { topic: "ReactJS Router", videos: [{ title: "ReactJS Router", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Router/story.html" }] },
    { topic: "ReactJS Conditional Rendering", videos: [{ title: "ReactJS Conditional Rendering", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Conditional+Rendering/story.html" }] },
    { topic: "ReactJS Event Handling", videos: [{ title: "ReactJS Event Handling", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Event+Handling/story.html" }] },
    { topic: "ReactJS Styles", videos: [{ title: "ReactJS Styles", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Styles/story.html" }] },
    { topic: "ReactJS Unit Testing & API Integration", videos: [{ title: "ReactJS Unit Testing & API Integration", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/React/ReactJS+Unit+Testing++API%C2%A0Integration/story.html" }] },
  ],
  "java exceptions and algorithms": [
    { topic: "Exception Handling Overview", videos: [{ title: "Exception Handling Overview", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/EXCEPTION+HANDLING+OVERVIEW/story.html" }] },
    { topic: "Exception Handling Methods", videos: [{ title: "Exception Handling Methods", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/Exception+Handling+Methods/story.html" }] },
    { topic: "Custom Exceptions", videos: [{ title: "Custom Exceptions", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/CUSTOM+EXCEPTIONS/story.html" }] },
    { topic: "File Handling using Byte Streams", videos: [{ title: "File Handling using Byte Streams", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/FILE+HANDLING+USING+BYTE+STREAMS/story.html" }] },
    { topic: "File Handling using Character Streams", videos: [{ title: "File Handling using Character Streams", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/FILE%20HANDLING%20USING%20CHARACTER%20STREAMS/story.html" }] },
    { topic: "Multi Threading", videos: [{ title: "Multi Threading", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/MULTITHREADING/story.html" }] },
    { topic: "Memory Management and Garbage Collection", videos: [{ title: "Memory Management and Garbage Collection", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/MEMORY%20MANAGEMENT%20AND%20GARBAGE%20COLLECTION/story.html" }] },
    { topic: "Sorting Algorithms", videos: [{ title: "Sorting Algorithms", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/SORTING%20ALGORITHMS/story.html" }] },
    { topic: "Searching Algorithms", videos: [{ title: "Searching Algorithms", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/SEARCHING%20ALGORITHMS/story.html" }] },
    { topic: "Working with Large Datasets", videos: [{ title: "Working with Large Datasets", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/WORKING+WITH+LARGE+DATASETS/story.html" }] },
    { topic: "UML Diagrams", videos: [{ title: "UML Diagrams", url: "https://d1sq67t1c2pewz.cloudfront.net/Staging/ScromPackages/java_exception_algorithms/UML+DIAGRAMS/story.html" }] }
  ],
  "data analysis": [
    { topic: "Topic 1: Data Analysis Introduction", videos: [{ title: "Data Analysis Introduction", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/data-analysis-introduction-scorm12-R_T5CbLQ/scormcontent/data_analysis_1.html" }] },
    { topic: "Topic 2: Numpy", videos: [{ title: "Numpy", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/numpy-scorm12-0gh0ZbW8/scormcontent/numpy.html" }] },
    { topic: "Topic 3: Pandas", videos: [{ title: "Pandas", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/pandas/scormcontent/pandas.html" }] },
    { topic: "Topic 4: Matplotlib", videos: [{ title: "Matplotlib", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/matplotlib-scorm12-9tXY9L3X/scormcontent/Matplotlib.html" }] },
    { topic: "Topic 5: Seaborn", videos: [{ title: "Seaborn", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/seaborn-scorm12-Va-ojPuV/scormcontent/Seaborn.html" }] },
    { topic: "Topic 6: EDA (Exploratory Data Analysis)", videos: [{ title: "EDA (Exploratory Data Analysis)", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/exploratory-data-analysis-eda-and-preprocessing-scorm12-7HilKppw/scormcontent/EDA.html" }] }
  ],
   "statistics": [
    { topic: "Topic 1: Introduction to Probability", videos: [{ title: "Introduction to Probability", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Statistics/introduction-to-probability+2.html" }] },
    { topic: "Topic 2: Discrete Probability Distributions", videos: [{ title: "Discrete Probability Distributions", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Statistics/discrete-probability.html" }] },
    { topic: "Topic 3: Continuous Probability Distributions", videos: [{ title: "Continuous Probability Distributions", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Statistics/continuous-probability.html" }] },
    { topic: "Topic 4: Descriptive Statistics", videos: [{ title: "Descriptive Statistics", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Statistics/descriptive-statistics.html" }] },
    { topic: "Topic 5: Inferential Statistics", videos: [{ title: "Inferential Statistics", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Statistics/inferential-statistics.html" }] }
  ],
    "advanced nlp": [
    { topic: "Topic 1: Seq2Seq Models", videos: [{ title: "Seq2Seq Models", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Advanced+NLP/seq-2-seq-models.html" }] },
    { topic: "Topic 2: Attention Based Models", videos: [{ title: "Attention Based Models", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Advanced+NLP/attention-based-models.html" }] },
    { topic: "Topic 3: Transformer Models", videos: [{ title: "Transformer Models", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Advanced+NLP/transformer-models.html" }] },
    { topic: "Topic 4: BERT MODEL", videos: [{ title: "BERT MODEL", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Advanced+NLP/bert-model-bidirectional-encoder.html" }] },
    { topic: "Topic 5: GPT Models Overview and Architecture", videos: [{ title: "GPT Models Overview and Architecture", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Advanced+NLP/gpt-models-overview.html" }] },
    { topic: "Topic 6: GPT Models Applications", videos: [{ title: "GPT Models Applications", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Advanced+NLP/t-5-models.html" }] }
  ],
  "nlp": [
    { topic: "Topic 1: Introduction to NLP", videos: [{ title: "Introduction to NLP", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/introduction-to-natural-language-processing-nlp-scorm12-nrFCB2mF/scormcontent/introduction-to-natural-language-processing.html" }] },
    { topic: "Topic 2: Text Preprocessing", videos: [{ title: "Text Preprocessing", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/text-processing-techniques-in-nlp-scorm12-9DjFlY4d/scormcontent/text-processing-techniques-in-nlp.html" }] },
    { topic: "Topic 3: Feature Engineering Techniques", videos: [
      { title: "Feature Engineering Techniques", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/feature-engineering-techniques-in-nlp-scorm12-5Da1swTT/scormcontent/feature-engineering-techniques-in-nlp.html" },
      { title: "Hands-on Feature Engineering", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/hands-on-pre-processing-and-feature-engineering-techniques-scorm12-ttj6O33X/scormcontent/hands-on-pre-processing-and-feature-engineering-techniques.html" }
    ] },
    
    { topic: "Topic 4: Syntax Analysis", videos: [{ title: "Syntax Analysis", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/syntax-analysis-scorm12-YXSVeCzX/scormcontent/syntax-analysis.html" }] },
    { topic: "Topic 5: Semantic Analysis -I", videos: [{ title: "Semantic Analysis -I", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/semantic-analysis-scorm12-9PVnxoRE/scormcontent/semantic-analysis.html" }] },
    { topic: "Topic 6: Semantic Analysis -II", videos: [{ title: "Semantic Analysis -II", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/sematic-analysis-ii-scorm12-4f2b0EtS/scormcontent/Nlp_topic_6.html" }] },
    { topic: "Topic 7: Semantic Analysis -III", videos: [{ title: "Semantic Analysis -III", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/semantic-analysis-iii-scorm12-6wgY72Ir/scormcontent/semantic-analysis-iii.html" }] },
    { topic: "Hands-on LSTM & NLU", videos: [{ title: "Hands-on LSTM & NLU", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/nlp/hands-on-lstm-nlu-scorm12-J_P6EVON/scormcontent/hands-on-lstm-nlu.html" }] }
  ],
  "deep learning": [
    { topic: "Topic 1: Introduction to Deep Learning", videos: [{ title: "Introduction to Deep Learning", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_1.html" }] },
    { topic: "Topic 2: Artificial Neural Network(ANN)", videos: [{ title: "Artificial Neural Network(ANN)", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_2.html" }] },
    { topic: "Topic 3: Hands on ANN For Regression", videos: [
      { title: "Hands on ANN For Regression", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_3.1.html" },
      { title: "Assignment on ANN for Regression", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_3.2.html" }
    ] },
    { topic: "Topic 4: Hands on ANN For Classification", videos: [
      { title: "Hands on ANN For Classification", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_4.1.html" },
      { title: "Assignment on ANN for Classification", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_4.2.html" }
    ] },
    { topic: "Topic 5: Convolutional Neural Network(CNN)", videos: [
      { title: "Convolutional Neural Network(CNN)", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_5.1.html" },
      { title: "Assignment on CNN", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_5.2.html" },
      { title: "Hands-on CNN", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_5.3.html" }
    ] },
    { topic: "Topic 6: Recurrent Neural Network(RNN)", videos: [{ title: "Recurrent Neural Network(RNN)", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_6.html" }] },
    { topic: "Topic 7: Long Short-Term Memory(LSTM)", videos: [{ title: "Long Short-Term Memory(LSTM)", url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/deep+learning/Topic_7.html" }] }
  ],
  "machine learning": [
  { 
    topic: "Topic 1: Machine Learning Introduction", 
    videos: [
      { 
        title: "Machine Learning Introduction", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/machine-learning-introduction-scorm12-2c-SFeHK.html" 
      }
    ] 
  },

  { 
    topic: "Topic 2: Regression-1", 
    videos: [
      { 
        title: "Regression-1", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/regression-1-scorm12-M-wGqOch.html" 
      }
    ] 
  },

  { 
    topic: "Topic 3: Regression-2", 
    videos: [
      { 
        title: "Regression-2", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/regression-2-scorm12-h77ZfqL1.html" 
      }
    ] 
  },

  { 
    topic: "Topic 4: Linear Regression", 
    videos: [
      { 
        title: "Hands on LR(Linear Regression)", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/hands-on-linear-regression-scorm12-nd6vRawn.html" 
      },
      { 
        title: "Assignment on LR(Linear Regression)", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/assignment-on-classification+copy+19.html" 
      }
    ] 
  },

  { 
    topic: "Topic 5: Classification and Logistic Regression", 
    videos: [
      { 
        title: "Classification and Logistic Regression", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/classification-and-logistic-regression-scorm12-JN6OpiBS.html" 
      }
    ] 
  },

  { 
    topic: "Topic 6: Decision Tree", 
    videos: [
      { 
        title: "Decision Tree", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/decision-tree-scorm12-gysDRI6G.html" 
      }
    ] 
  },

  { 
    topic: "Topic 7: Random Forest", 
    videos: [
      { 
        title: "Random Forest", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/random-forest-scorm12-5kZpOH7O.html" 
      }
    ] 
  },

  { 
    topic: "Topic 8: SMOTE", 
    videos: [
      { 
        title: "SMOTE", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/smote-scorm12-RL2a5idQ.html" 
      }
    ] 
  },

  { 
    topic: "Topic 9: Feature Selection Methods", 
    videos: [
      { 
        title: "Feature Selection Methods", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/feature-selection-methods-scorm12-wmOIgg3k.html" 
      }
    ] 
  },

  { 
    topic: "Topic 10: Support Vector Machine(SVM)", 
    videos: [
      { 
        title: "Support Vector Machine(SVM)", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/svm-support-vector-machine-scorm12-2yk6ujqv.html" 
      }
    ] 
  },

  { 
    topic: "Topic 11: K - Nearest Neighbor (KNN)", 
    videos: [
      { 
        title: "K - Nearest Neighbor (KNN)", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/k-nearest-neighbor-knn-scorm12-Szln5zIr.html" 
      }
    ] 
  },

  { 
    topic: "Topic 12: Naive Bayes", 
    videos: [
      { 
        title: "Naive Bayes", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/naive-bayes-scorm12-q4ltrI7D.html" 
      }
    ] 
  },

  { 
    topic: "Topic 13: Hyper parameter tuning", 
    videos: [
      { 
        title: "Hyper parameter tuning: GridsearchCV, RandomSearchCV", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/hyperparameter-tuning-in-machine-learning-scorm12-_XYoYPT8.html" 
      },
      { 
        title: "Assignment on Classification", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/assignment-on-classification-scorm12-gh3XjHc5.html" 
      }
    ] 
  },

  { 
    topic: "Topic 14: Un-supervised learning", 
    videos: [
      { 
        title: "Un-supervised learning", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/un-supervised-learning-scorm12-6eXtsKoD.html" 
      }
    ] 
  },

  { 
    topic: "Topic 15: Clustering", 
    videos: [
      { 
        title: "Clustering", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/clustering-scorm12-_5kE6dVN.html" 
      }
    ] 
  },

  { 
    topic: "Topic 16: Introduction to K- mean Clustering", 
    videos: [
      { 
        title: "Introduction to K- mean Clustering", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/k-means-clustering-scorm12-FCF3nDFC.html" 
      }
    ] 
  },

  { 
    topic: "Topic 17: Hierarchical Clustering", 
    videos: [
      { 
        title: "Hierarchical Clustering", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/hierarchical-clustering-scorm12-HzSKuuJA.html" 
      }
    ] 
  },

  { 
    topic: "Topic 18: DBSCAN", 
    videos: [
      { 
        title: "DBSCAN", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/dbscan-scorm12-URjRbZfj.html" 
      },
      { 
        title: "Assignment on Clustering", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/assignment-on-clustering-scorm12-o4Via6eE.html" 
      }
    ] 
  },

  { 
    topic: "Topic 19: Dimensionality Reduction", 
    videos: [
      { 
        title: "Dimensionality Reduction", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/dimensionality-reduction-scorm12-WBwZ4ZIC.html" 
      }
    ] 
  },

  { 
    topic: "Topic 20: Principal Component Analysis (PCA)", 
    videos: [
      { 
        title: "Principal Component Analysis (PCA)", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/principal-component-analysis-pca-scorm12-D2UI-aHz.html" 
      },
      { 
        title: "Assignment on Dimensionality reduction", 
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/machinelearning/assignment-on-dimensionality-reduction-scorm12-n00Bwd_Z.html" 
      }
    ] 
  }
],
"generative ai": [
  {
    topic: "Topic 1: Foundations of Generative AI",
    videos: [
      {
        title: "Foundations of Generative AI",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/foundations-of-generative-ai.html"
      }
    ]
  },

  {
    topic: "Topic 2: LLMs and GenAI in Action",
    videos: [
      {
        title: "LLMs and GenAI in Action",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/ll-ms-and-gen-ai-in-action.html"
      }
    ]
  },

  {
    topic: "Topic 3: LLM Architecture & GenAI Ecosystem",
    videos: [
      {
        title: "LLM Architecture & GenAI Ecosystem",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/llm-architecture-gen-ai.html"
      }
    ]
  },

  {
    topic: "Topic 4: Introduction to Langchain and Open AI LLMs",
    videos: [
      {
        title: "Introduction to Langchain and Open AI LLMs",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/introduction-to-langchain.html"
      }
    ]
  },

  {
    topic: "Topic 5: Building RAG Architecture using Langchain and OpenAI",
    videos: [
      {
        title: "Building RAG Architecture using Langchain and OpenAI",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/building-rag-architecture.html"
      }
    ]
  },

  {
    topic: "Topic 6: Hands-on Gen AI with Bedrock and Gemini",
    videos: [
      {
        title: "Hands-on Gen AI with Bedrock and Gemini",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/introduction-to-amazon-bedrock.html"
      }
    ]
  },

  {
    topic: "Topic 7: Understanding LLM model parameters",
    videos: [
      {
        title: "Understanding LLM model parameters",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/understanding-llm-model.html"
      }
    ]
  },

  {
    topic: "Topic 8: End-to-End Project Builds Using LangChain & Streamlit- Part-1",
    videos: [
      {
        title: "End-to-End Project Builds Using LangChain & Streamlit- Part-1",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/building-a-chatbot.html"
      }
    ]
  },

  {
    topic: "Topic 9: Building a Chatbot using LangChain, Bedrock & Streamlit Using RAG - Part-2",
    videos: [
      {
        title: "Building a Chatbot using LangChain, Bedrock & Streamlit Using RAG - Part-2",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/building-a-chatbot-using-lang-chain-bedrock-streamlit-using-rag-part-2.html"
      }
    ]
  },

  {
    topic: "Topic 10: Fine-tuning and Model Optimization",
    videos: [
      {
        title: "Fine-tuning and Model Optimization",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/fine-tuning-and-model-optimization.html"
      }
    ]
  },

  {
    topic: "Topic 11: GenAI Lifecycle & Use Cases",
    videos: [
      {
        title: "GenAI Lifecycle & Use Cases",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/generative-ai-project-lifecycle.html"
      }
    ]
  },

  {
    topic: "Assignment 1: BizAssist AI – Building a Domain-Aware Assistant with LangChain",
    videos: [
      {
        title: "BizAssist AI – Building a Domain-Aware Assistant with LangChain",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/assignment-1.html"
      }
    ]
  },

  {
    topic: "Assignment 2: GenScope Consulting – Generative AI Simulator for Industry Automation",
    videos: [
      {
        title: "GenScope Consulting – Generative AI Simulator for Industry Automation",
        url: "https://bitlabs-app.s3.ap-south-1.amazonaws.com/Staging/ScromPackages/Generative_AI/assignment-2.html"
      }
    ]
  }
],

};

const CourseDetails = () => {
  const { courseName } = useParams();
  const location = useLocation();
  const { user } = useUserContext();
  
  const safeCourseName = courseName || '';
const currentCourseId = getCourseId(safeCourseName);

const shouldShowMarkAsDone =
    markAsDoneAllowedCourses.includes(currentCourseId);

  // Provide default value to prevent toLowerCase error
  
  const [selectedTopicIndex, setSelectedTopicIndex] = useState(1);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [topicProgress, setTopicProgress] = useState({});
  const [overallProgress, setOverallProgress] = useState(0);
  const [courseProgressId, setCourseProgressId] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sidebarView, setSidebarView] = useState("topics");
  const [collapsedGroups, setCollapsedGroups] = useState({});
  const [viewingAssignment, setViewingAssignment] = useState(false);
  const [assignmentType, setAssignmentType] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({ title: "", message: "", subMessage: "", type: "topic" });
  const [assignmentCompletion, setAssignmentCompletion] = useState({
    html: false,
    css1: false,
    css2: false,
    forms: false,
    python1: false, python2: false, python3: false, python4: false, python5: false, python6: false, python7: false, python8: false, python9: false, python10: false, python11: false,
    sql1: false, sql2: false, sql3: false, sql4: false, sql5: false, sql6: false, sql7: false, sql8: false, sql9: false
  });

  const navigate = useNavigate();

  const currentPath = location.pathname.toLowerCase();

  const allowedRoutes = [
    '/courses/html',
    '/courses/css',
    '/course/html',
    '/course/css',
    '/course/python',
    '/courses/python',
    '/course/sql',
    '/courses/sql',
    '/assignment/first-html-page'
  ];

  const isAssignmentAllowed = allowedRoutes.some(route => currentPath.startsWith(route));
  const applicantId = user?.id;

  // ── Interview Preparedness flag ──────────────────────────────────────────
  const isInterviewPrep = safeCourseName.toLowerCase() === "interview preparedness";

  // Refs for state to avoid stale closures in setTimeout callbacks
  const topicProgressRef = useRef({});
  const assignmentCompletionRef = useRef({
    html: false, css1: false, css2: false, forms: false,
    python1: false, python2: false, python3: false, python4: false, python5: false, python6: false, python7: false, python8: false, python9: false, python10: false, python11: false,
    sql1: false, sql2: false, sql3: false, sql4: false, sql5: false, sql6: false, sql7: false, sql8: false, sql9: false
  });

  // Ref keeps the current topic index reachable inside async callbacks/effects
  const playerRef = useRef(null);
  const topicIndexRef = useRef(1);
  topicIndexRef.current = selectedTopicIndex;

  const handleProgressUpdateRef = useRef(null);

  const courseContent = COURSE_DATA[safeCourseName.toLowerCase()] || COURSE_DATA[courseName] || [];

  const getTopicProgressFromStorage = useCallback((cName, topicIdx) => {
    const keysToCheck = [
      `scorm_${cName}_${topicIdx}`,
      `scorm_${safeCourseName.toLowerCase()}_${topicIdx}`,
      `scorm_${courseName}_${topicIdx}`,
      `articulate_course_${cName}_${topicIdx}_progress`,
      `articulate_course_${courseName}_${topicIdx}_progress`,
      `articulate_course_${safeCourseName.toLowerCase()}_${topicIdx}_progress`
    ];

    for (const key of keysToCheck) {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) continue;
        const data = JSON.parse(raw);

        // Passed / completed check
        const status = data["cmi.core.lesson_status"] || data["cmi.core.completion_status"] || data["cmi.completion_status"];
        if (status === "passed" || status === "completed") return 100;

        // Score check
        const rawScore = data["cmi.core.score.raw"] || data["cmi.score.raw"];
        const scaledScore = data["cmi.score.scaled"];
        if (scaledScore && Number(scaledScore) > 0) return Math.min(100, Math.round(Number(scaledScore) * 100));
        if (rawScore && Number(rawScore) > 0) return Math.min(100, Math.round(Number(rawScore)));

        // Visited / Total check
        const visited = typeof data.visited === "number" ? data.visited : (Array.isArray(data.visited) ? data.visited.length : 0);
        const total = data.total || 0;
        if (total > 0 && visited > 0) {
          return Math.min(100, Math.round((visited / total) * 100));
        }

        // Suspend Data check
        const suspendData = data["cmi.suspend_data"];
        if (suspendData) {
          try {
            const parsed = typeof suspendData === "string" ? JSON.parse(suspendData) : suspendData;
            if (typeof parsed.progress === "number") return Math.min(100, Math.round(parsed.progress));
            if (Array.isArray(parsed.visited) && parsed.total) {
              return Math.min(100, Math.round((parsed.visited.length / parsed.total) * 100));
            }
          } catch (_) {
            const matchProg = String(suspendData).match(/(?:progress|percentage)["=:]+(\d+)/i);
            if (matchProg) return Math.min(100, Number(matchProg[1]));
          }
        }

        // Lesson Location check (e.g., "lesson-6", "6/12", "6")
        const location = data["cmi.core.lesson_location"] || data["cmi.location"];
        if (location) {
          const fracMatch = String(location).match(/(\d+)\s*\/\s*(\d+)/);
          if (fracMatch) {
            const num = Number(fracMatch[1]);
            const den = Number(fracMatch[2]);
            if (den > 0) return Math.min(100, Math.round((num / den) * 100));
          }
          const numMatch = String(location).match(/\d+/);
          if (numMatch) {
            const num = Number(numMatch[0]);
            if (num > 0 && num <= 12) return Math.min(100, Math.round((num / 12) * 100));
          }
        }
      } catch (e) { }
    }

    return 0;
  }, [courseName, safeCourseName]);

  // ── 1. SCORM 1.2 API shim ─────────────────────────────────────────────────
  useEffect(() => {
    const storeKey = () => `scorm_${safeCourseName.toLowerCase()}_${topicIndexRef.current}`;

    const readStore = () => { try { return JSON.parse(localStorage.getItem(storeKey()) || "{}"); } catch { return {}; } };
    const writeStore = (obj) => { localStorage.setItem(storeKey(), JSON.stringify(obj)); };

    window.API = {
      LMSInitialize: (_) => { console.log("[SCORM] Init topic", topicIndexRef.current); return "true"; },
      LMSFinish: (_) => {
        console.log("[SCORM] Finish topic", topicIndexRef.current);
        const store = readStore();
        const status = store["cmi.core.lesson_status"] || store["cmi.core.completion_status"] || store["cmi.completion_status"];
        if (status === "passed" || status === "completed") {
          if (handleProgressUpdateRef.current) {
            handleProgressUpdateRef.current(100);
          }
        }
        return "true";
      },
      LMSGetValue: (key) => {
        const val = readStore()[key];
        const out = val !== undefined ? String(val) : "";
        console.log("[SCORM] Get", key, "→", out);
        return out;
      },
      LMSSetValue: (key, val) => {
        console.log("[SCORM] Set", key, "=", val);
        const store = readStore();
        store[key] = val;
        writeStore(store);

        const currentTopicIdx = topicIndexRef.current;
        const computedP = getTopicProgressFromStorage(safeCourseName, currentTopicIdx);
        if (computedP > 0 && handleProgressUpdateRef.current) {
          handleProgressUpdateRef.current(computedP);
        } else if (
          key === "cmi.core.lesson_status" ||
          key === "cmi.core.completion_status" ||
          key === "cmi.completion_status"
        ) {
          if (val === "passed" || val === "completed") {
            console.log("[SCORM] Lesson status passed/completed! Triggering 100% progress update");
            if (handleProgressUpdateRef.current) {
              handleProgressUpdateRef.current(100);
            }
          }
        }
        return "true";
      },
      LMSCommit: (_) => {
        const store = readStore();
        const status = store["cmi.core.lesson_status"] || store["cmi.core.completion_status"] || store["cmi.completion_status"];
        if (status === "passed" || status === "completed") {
          if (handleProgressUpdateRef.current) {
            handleProgressUpdateRef.current(100);
          }
        }
        return "true";
      },
      LMSGetLastError: () => "0",
      LMSGetErrorString: (_) => "",
      LMSGetDiagnostic: (_) => "",
    };

    return () => { delete window.API; };
  }, [safeCourseName, getTopicProgressFromStorage]);

  // ── SCORM Window Message Listener & Auto-Sync Interval ─────────────────────
  useEffect(() => {
    const handleScormMessage = (event) => {
      const data = event.data;
      if (!data) return;

      let p = 0;
      if (typeof data.progress === "number") {
        p = Math.round(data.progress);
      } else if (data.type === "SCORM_PROGRESS" || data.type === "progress") {
        const visited = data.current || data.visited || data.value || 0;
        const total = data.total || 12;
        p = Math.min(100, Math.round((visited / total) * 100));
      } else if (data.type === "SCORM_EVENT") {
        const visited = data.slideNumber || data.visited || data.current || 0;
        const total = data.totalSlides || data.total || 12;
        if (visited > 0 && total > 0) {
          p = Math.min(100, Math.round((visited / total) * 100));
        }
      }

      if (p > 0 && handleProgressUpdateRef.current) {
        handleProgressUpdateRef.current(p);
      }
    };

    window.addEventListener("message", handleScormMessage);

    const timer = setInterval(() => {
      const idx = topicIndexRef.current;
      const currentP = topicProgressRef.current[idx] || 0;
      const localP = getTopicProgressFromStorage(safeCourseName, idx);
      if (localP > currentP && handleProgressUpdateRef.current) {
        console.log(`[SCORM Auto-Sync] Topic ${idx} progress updated from ${currentP}% to ${localP}%`);
        handleProgressUpdateRef.current(localP);
      }
    }, 2000);

    return () => {
      window.removeEventListener("message", handleScormMessage);
      clearInterval(timer);
    };
  }, [safeCourseName, getTopicProgressFromStorage]); // re-install only when course changes; topic index is read via ref

  // ── 2. Load saved progress from backend + restore last visited topic ───────────────────
  useEffect(() => {
    const loadProgress = async () => {
      if (!applicantId) return;
      try {
        setLoading(true);
        // Get all courses progress for this applicant
        const applicantCourses = await ProgressAPIService.getApplicantProgress(applicantId);

        // Find the current course progress
        const currentCourse = applicantCourses.find(course =>
          course.courseName?.toLowerCase() === safeCourseName.toLowerCase()
        );

        if (currentCourse) {
          setCourseProgressId(currentCourse.id);

          // Get topics progress for this course
          const topicsProgress = await ProgressAPIService.getCourseTopics(currentCourse.id);
          const progressMap = {};
          topicsProgress.forEach(topic => {
            progressMap[topic.topicIndex] = topic.topicProgress;
          });
          // Check local SCORM stores for any completed or intermediate progress and sync them
          for (let i = 1; i <= courseContent.length; i++) {
            const localP = getTopicProgressFromStorage(courseName, i);
            if (localP > (progressMap[i] || 0)) {
              progressMap[i] = localP;
            }
          }
          topicProgressRef.current = progressMap;
          setTopicProgress(progressMap);

          // Calculate and sync overall progress
          const totalProgress = Object.values(progressMap).reduce((a, b) => a + b, 0);
          const calculatedProgress = courseContent.length > 0 ? Math.round(totalProgress / courseContent.length) : 0;
          setOverallProgress(calculatedProgress);

          // Sync any completed local SCORM progress to backend
          Object.keys(progressMap).forEach(idxStr => {
            const idx = Number(idxStr);
            const p = progressMap[idx];
            if (p > 0 && applicantId) {
              ProgressAPIService.saveProgress({
                applicantId,
                courseId: getCourseId(courseName),
                courseName,
                topicIndex: idx,
                topicName: courseContent[idx-1]?.topic || '',
                topicProgress: p,
                overallProgress: calculatedProgress
              }).catch(err => console.error("Error syncing SCORM progress on load:", err));
            }
          });

         setOverallProgress(calculatedProgress);

          // Find the last accessed topic (highest progress that's not 100%)
          const lastTopicIndex = topicsProgress.reduce((lastIdx, topic) => {
  return topic.topicProgress < 100 && topic.topicIndex > lastIdx
    ? topic.topicIndex
    : lastIdx;
}, 1);
          // Find the first incomplete topic (progress < 100)
         const firstIncompleteTopic = topicsProgress.reduce((firstIdx, topic) => {
  return topic.topicProgress < 100 && topic.topicIndex < firstIdx
    ? topic.topicIndex
    : firstIdx;
}, courseContent.length + 1);
          // If there are incomplete topics, go to the first one; otherwise go to last completed
          const targetTopicIndex =
  firstIncompleteTopic <= courseContent.length
    ? firstIncompleteTopic
    : lastTopicIndex;

setSelectedTopicIndex(
  targetTopicIndex >= 1 && targetTopicIndex <= courseContent.length
    ? targetTopicIndex
    : 1
);
        } else {
          // Initialize with zero progress if no course progress exists
          setOverallProgress(0);
          topicProgressRef.current = {};
          setTopicProgress({});
          setSelectedTopicIndex(1);

          // Save initial progress entry so row is automatically created in DB table
          if (applicantId && getCourseId(safeCourseName)) {
            ProgressAPIService.saveProgress({
              applicantId,
              courseId: getCourseId(safeCourseName),
              courseName: safeCourseName.toLowerCase(),
              topicIndex: 1,
              topicName: courseContent[0]?.topic || '',
              topicProgress: 0,
              overallProgress: 0
            }).catch(err => console.error("Error creating initial course progress:", err));
          }
        }
      } catch (error) {
        console.error('Error loading progress:', error);
        // Fallback to zero progress
        setOverallProgress(0);
        topicProgressRef.current = {};
        setTopicProgress({});
        setSelectedTopicIndex(1);
      } finally {
        setLoading(false);
      }
    };

    loadProgress();
  }, [courseName, applicantId]);

  // ── 3. Progress update — save to backend ────────────────────────────────────
  const handleProgressUpdate = useCallback(async (p) => {
    if (!applicantId) return;
    const numericP = Number(p);
    const idx = topicIndexRef.current;
    const currentProgress = topicProgressRef.current[idx] || 0;

    if (numericP <= currentProgress) return; // ✅ progress can only move forward

    try {
      // Update local state immediately for UI responsiveness
      const newTopicProgress = { ...topicProgressRef.current, [idx]: numericP };
      topicProgressRef.current = newTopicProgress;
      setTopicProgress(newTopicProgress);

      // Calculate new overall progress
      const totalProgress = Object.values(newTopicProgress).reduce((a, b) => a + b, 0);
      const newOverallProgress = Math.round(totalProgress / courseContent.length);
      setOverallProgress(newOverallProgress);

      // Save to backend — include overallProgress so the backend stores it
      const response = await ProgressAPIService.saveProgress({
        
        applicantId,
        courseId: getCourseId(courseName),
        courseName,
        topicIndex: idx,
        topicName: courseContent[idx-1]?.topic || '',
        topicProgress: numericP,
        overallProgress: newOverallProgress
      });

      console.log("========== PROGRESS API RESPONSE ==========");
console.log(response);
console.log("============================================");

      if (numericP === 100) {
        handleTopicComplete(idx);
      }
    } catch (error) {
      console.error('Error saving progress:', error);
      const rollbackProgress = { ...topicProgress, [idx]: currentProgress };
      topicProgressRef.current = rollbackProgress;
      setTopicProgress(rollbackProgress);
    }
  }, [applicantId, courseName, courseContent, topicProgress]);

  handleProgressUpdateRef.current = handleProgressUpdate;

  // ── 1. Utility Callbacks ──────────────────────────────────────────────────
  const getTopicLockedStatus = useCallback((index) => {
    if (index === 1) return false;
    const progress = topicProgressRef.current[index-1] || 0;
    if (progress > 0) return false; // Already started topics are never locked

    // Interview Preparedness has no topic lock gates — all topics accessible
    if (
      safeCourseName.toLowerCase() === "interview preparedness"
    ) {
      return false;
    }

    // Default rule: Previous topic must be 100%
    const prevProgress = topicProgressRef.current[index - 1] || 0;
    if (prevProgress < 100) return true;

    // Interview Preparedness has no assignment gates — unlock on topic progress only
    if (safeCourseName.toLowerCase() === "interview preparedness") return false;

    if (safeCourseName.toLowerCase() === "python") {
      const prevAssignmentMap = {
        2: 'python1', 3: 'python2', 4: 'python3', 6: 'python4', 7: 'python5',
        8: 'python6', 9: 'python7', 10: 'python8', 11: 'python9', 12: 'python10', 13: 'python11'
      };
      const prevAssignKey = prevAssignmentMap[index];
      if (prevAssignKey && !assignmentCompletionRef.current[prevAssignKey]) return true;
    } else if (safeCourseName.toLowerCase() === "sql") {
      const prevAssignmentMap = {
        2: 'sql1', 3: 'sql2', 4: 'sql3', 5: 'sql4', 6: 'sql5',
        7: 'sql6', 8: 'sql7', 9: 'sql8', 10: 'sql9'
      };
      const prevAssignKey = prevAssignmentMap[index];
      if (prevAssignKey && !assignmentCompletionRef.current[prevAssignKey]) return true;

    } else if (safeCourseName.toLowerCase() === "html & css") {
      // HTML/CSS logic
      if (index === 2 && !assignmentCompletionRef.current.html) return true;
      if (index === 3 && !assignmentCompletionRef.current.css1) return true;
      if (index === 4 && !assignmentCompletionRef.current.css2) return true;
    }
    return false;
  }, [safeCourseName]);

const selectTopic = useCallback((index) => {
  console.log("=================================");
  console.log("CLICKED:", index);
  console.log("CURRENT:", selectedTopicIndex);
  console.log("LOCKED:", getTopicLockedStatus(index));
  console.log("=================================");

  setViewingAssignment(false);

  if (getTopicLockedStatus(index)) {
    console.log("TOPIC IS LOCKED");
    return;
  }

  console.log("SETTING INDEX:", index);

  // When moving to a new topic, always start with its first video
  setSelectedTopicIndex(index);
  setSelectedVideoIndex(0);

}, [selectedTopicIndex, getTopicLockedStatus]);

useEffect(() => {
    console.log("SELECTED TOPIC CHANGED:", selectedTopicIndex);

    console.log(
        "VIDEO:",
        courseContent[selectedTopicIndex-1]?.videos?.[0]?.url
    );

}, [selectedTopicIndex]);

  // Function to toggle fullscreen
  const toggleFullscreen = useCallback(() => {
    if (!playerRef.current) return;
    const fsEl = document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
    if (!fsEl) {
      const reqFS = playerRef.current.requestFullscreen ||
        playerRef.current.webkitRequestFullscreen ||
        playerRef.current.mozRequestFullScreen ||
        playerRef.current.msRequestFullscreen;
      if (reqFS) {
        reqFS.call(playerRef.current).catch(err => {
          console.error(`Error attempting to enable full-screen mode: ${err.message}`);
        });
      }
    } else {
      const exitFS = document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.mozCancelFullScreen ||
        document.msExitFullscreen;
      if (exitFS) {
        exitFS.call(document);
      }
    }
  }, []);

  const handleModuleComplete = useCallback((index) => {
    const nextIdx = index + 1;
    const isLastModule = nextIdx > courseContent.length;

    if (isLastModule) {
      setPopupContent({
        title: "🏆 Congratulations!",
        message: `You have successfully completed the ${courseName} course.`,
        subMessage: "Your certificate is now ready for download.",
        type: "course"
      });
    } else {
      setPopupContent({
        title: "🎉 Great Job!",
        message: `You completed all ${courseContent[index-1].topic} assignments.`,
        subMessage: `${courseContent[nextIdx-1].topic} is now unlocked.`,
        type: "module"
      });
    }
    setShowSuccessPopup(true);

    setTimeout(() => {
      setShowSuccessPopup(false);
      if (!isLastModule) selectTopic(nextIdx);
    }, 3000);
  }, [courseContent, courseName, selectTopic]);

  const handleTopicComplete = (index) => {
    const topic = courseContent[index-1];
    if (!topic) return;

    setPopupContent({
      title: "🎉 Congratulations!",
      message: `You successfully completed ${topic.topic}.`,
      subMessage: "Your next assignment is now unlocked.",
      type: "topic"
    });
    setShowSuccessPopup(true);

    setTimeout(() => {
      setShowSuccessPopup(false);

      // Interview Preparedness, Java, Spring Boot, JavaScript & ES6, React.js, Java Exceptions & Algorithms, Data Analysis:
      // no assignments — always advance to next topic
      if (safeCourseName.toLowerCase() === "interview preparedness" ||
        safeCourseName.toLowerCase() === "java" ||
        safeCourseName.toLowerCase() === "spring boot" ||
        safeCourseName.toLowerCase() === "javascript & es6" ||
        safeCourseName.toLowerCase() === "react" ||
        safeCourseName.toLowerCase() === "java exceptions and algorithms" ||
        safeCourseName.toLowerCase() === "data analysis" ||
        safeCourseName.toLowerCase() === "nlp" ||
        safeCourseName.toLowerCase() === "deep learning" ||
        safeCourseName.toLowerCase() === "deeplearning") {
        const nextIdx = index + 1;
        if (nextIdx <= courseContent.length) selectTopic(nextIdx);
        return;
      }

      let assignments = [];
      if (safeCourseName.toLowerCase() === "python") {
        assignments = [
          null,
          { type: 'python1' }, { type: 'python2' }, { type: 'python3' }, null,
          { type: 'python4' }, { type: 'python5' }, { type: 'python6' },
          { type: 'python7' }, { type: 'python8' }, { type: 'python9' },
          { type: 'python10' }, { type: 'python11' }
        ];
      } else if (safeCourseName.toLowerCase() === "sql") {
        assignments = [
          null,
          { type: 'employee_table' },
          { type: 'employee_data' },
          { type: 'employee_sales' },
          { type: 'customer_sales' },
          { type: 'student' },
          { type: 'customer_table' },
          { type: 'sales_customers_orders' },
          { type: 'customer_sub_queries' },
          { type: 'banks' },
          null
        ];
      } else {
        assignments = [
          null,
          { type: 'html' },
          { type: 'styling' },
          { type: 'styling2' },
          { type: 'forms' }
        ];
      }
      if (assignments[index-1]) {
        setSidebarView('assignments');
        setViewingAssignment(true);
        setAssignmentType(assignments[index-1].type);
      } else {
        // No assignment for this topic, move to next if available
        const nextIdx = index + 1;
        if (nextIdx <= courseContent.length) {
          selectTopic(nextIdx);
        }
      }
    }, 3000);
  };

  // Sync assignment completion state from backend
  const syncAssignments = useCallback(async () => {
    if (!applicantId) return;
    try {
      const res = await getAllAssignmentsByApplicant(applicantId);
      const assignments = Array.isArray(res) ? res : (res ? [res] : []);

      const completedIds = {
        html: new Set(),
        css1: new Set(),
        css2: new Set(),
        forms: new Set(),
        python: new Set(),
        sql: new Set()
      };
      const totals = { html: 10, css1: 6, css2: 8, forms: 5, python: 11 };

      assignments.forEach(item => {
        let id = item.assignmentNumber ?? item.assignment_number ?? item.assignmentId ?? item.assignment_id ?? item.id;
        const numId = Number(id);
        const status = (item.status || item.assignmentStatus || item.assignment_status || "").toUpperCase();
        const hasCode = !!(item.assignmentCode || item.assignment_code || item.code || item.submittedCode);
        const isDone = status === 'COMPLETED' || status === 'SUBMITTED' || hasCode;

        if (isDone && !isNaN(numId)) {
          if (numId >= 1 && numId <= 10) completedIds.html.add(numId);
          if (numId >= 101 && numId <= 106) completedIds.css1.add(numId);
          if (numId >= 201 && numId <= 208) completedIds.css2.add(numId);
          if (numId >= 301 && numId <= 305) completedIds.forms.add(numId);
          if (numId >= 401 && numId <= 411) completedIds.python.add(numId);
          if (numId >= 5011 && numId <= 5094) completedIds.sql.add(numId);
        }
      });

      const newCompletion = {
        html: completedIds.html.size >= totals.html || completedIds.html.has(10),
        css1: completedIds.css1.size >= totals.css1 || completedIds.css1.has(106),
        css2: completedIds.css2.size >= totals.css2 || completedIds.css2.has(208),
        forms: completedIds.forms.size >= totals.forms || completedIds.forms.has(305),
        python1: completedIds.python.has(401),
        python2: completedIds.python.has(402),
        python3: completedIds.python.has(403),
        python4: completedIds.python.has(404),
        python5: completedIds.python.has(405),
        python6: completedIds.python.has(406),
        python7: completedIds.python.has(407),
        python8: completedIds.python.has(408),
        python9: completedIds.python.has(409),
        python10: completedIds.python.has(410),
        python11: completedIds.python.has(411),
        sql1: completedIds.sql.has(5015),
        sql2: completedIds.sql.has(5025),
        sql3: completedIds.sql.has(5035),
        sql4: completedIds.sql.has(5046),
        sql5: completedIds.sql.has(5054),
        sql6: completedIds.sql.has(5065),
        sql7: completedIds.sql.has(5074),
        sql8: completedIds.sql.has(5084),
        sql9: completedIds.sql.has(5094)
      };
      assignmentCompletionRef.current = newCompletion;
      setAssignmentCompletion(newCompletion);
    } catch (error) {
      console.error('[CourseDetails] Sync Error:', error);
    }
  }, [applicantId]);

  useEffect(() => {
    syncAssignments();
  }, [syncAssignments]);

  useEffect(() => {
    const handleAssignmentDone = (e) => {
      syncAssignments();
      const { assignmentId } = e.detail;
      const id = Number(assignmentId);

      const groups = [
        { id: 10, index: 1 },
        { id: 106, index: 2 },
        { id: 208, index: 3 },
        { id: 305, index: 4 }
      ];

      const group = groups.find(g => g.id === id);
      if (group) {
        const htmlCssKeys = { 10: 'html', 106: 'css1', 208: 'css2', 305: 'forms' };
        const compKey = htmlCssKeys[id];
        if (compKey) {
          setAssignmentCompletion(prev => {
            const next = { ...prev, [compKey]: true };
            assignmentCompletionRef.current = next;
            return next;
          });
        }
        handleModuleComplete(group.index);
      }

      // Handle Python individual assignment completion logic
      if (id >= 401 && id <= 411) {
        // Immediately update local state for better responsiveness
        const completionKey = `python${id - 400}`;
        setAssignmentCompletion(prev => {
          const next = { ...prev, [completionKey]: true };
          assignmentCompletionRef.current = next;
          return next;
        });

        syncAssignments().then(() => {
          // Auto-advance logic for Python topics
          const pythonNextTopicMap = {
            401: 2, // Convert Distance (Topic 1) -> Operators (Topic 2)
            402: 3, // Total Marks (Topic 2) -> Conditionals (Topic 3)
            403: 4, // Interest (Topic 3) -> Loops (Topic 4)
            404: 6, // Tuple (Topic 5) -> DS Part 2 (Topic 6)
            405: 7, // Remove Dups (Topic 6) -> DS Part 3 (Topic 7)
            406: 8, // Capitalize (Topic 7) -> Functions (Topic 8)
            407: 9, // Cond Capitalize (Topic 8) -> Modules (Topic 9)
            408: 10, // Hypotenuse (Topic 9) -> OOPS (Topic 10)
            409: 11, // Roster (Topic 10) -> Constructors (Topic 11)
            410: 12, // Animals (Topic 11) -> Inheritance (Topic 12)
            411: 13, // Shape (Topic 12) -> Inheritance (Topic 13)
          };

          const nextTopicIdx = pythonNextTopicMap[id];
          if (nextTopicIdx !== undefined) {
            // Small delay to ensure React has processed the state update for the lock
            setTimeout(() => selectTopic(nextTopicIdx), 400);
          }
        });
      }

      // Handle SQL individual assignment completion logic
      if (id >= 5011 && id <= 5094) {
        let completionKey = null;
        if (id === 5015) completionKey = 'sql1';
        else if (id === 5025) completionKey = 'sql2';
        else if (id === 5035) completionKey = 'sql3';
        else if (id === 5046) completionKey = 'sql4';
        else if (id === 5054) completionKey = 'sql5';
        else if (id === 5065) completionKey = 'sql6';
        else if (id === 5074) completionKey = 'sql7';
        else if (id === 5084) completionKey = 'sql8';
        else if (id === 5094) completionKey = 'sql9';

        if (completionKey) {
          setAssignmentCompletion(prev => {
            const next = { ...prev, [completionKey]: true };
            assignmentCompletionRef.current = next;
            return next;
          });

          syncAssignments().then(() => {
            const sqlNextTopicMap = {
              'sql1': 2,
              'sql2': 3,
              'sql3': 4,
              'sql4': 5,
              'sql5': 6,
              'sql6': 7,
              'sql7': 8,
              'sql8': 9,
              'sql9': 10
            };
            const nextTopicIdx = sqlNextTopicMap[completionKey];
            if (nextTopicIdx !== undefined) {
              setTimeout(() => selectTopic(nextTopicIdx), 400);
            }
          });
        }
      }

    };

    window.addEventListener('assignmentCompleted', handleAssignmentDone);
    return () => window.removeEventListener('assignmentCompleted', handleAssignmentDone);
  }, [syncAssignments, handleModuleComplete, selectTopic]);

  const handleAssignmentClick = (type, index) => {
    if (!isAssignmentAllowed) return;
    setAssignmentType(type);
    setViewingAssignment(true);
    if (index !== undefined) {
      setSelectedTopicIndex(index);
    }
  };

  const handleAssignmentNavigate = (newAssignmentId) => {
    const id = Number(newAssignmentId);
    if (safeCourseName.toLowerCase() === "python") {
      const pythonTopicMap = {
        401: 1, 402: 2, 403: 3, 404: 5, 405: 6, 406: 7, 407: 8, 408: 9, 409: 10, 410: 11, 411: 12
      };
      const topicIdx = pythonTopicMap[id];
      if (topicIdx !== undefined) {
        setSelectedTopicIndex(topicIdx);
      }
    }
  };

  const handleCloseAssignment = (goToPrevTopic = false) => {
    setViewingAssignment(false);
    if (goToPrevTopic && selectedTopicIndex > 1) {
      selectTopic(selectedTopicIndex - 1);
    }
  };

  const handleNextTopic = () => {
    const nextIdx = selectedTopicIndex + 1;

    if (nextIdx <= courseContent.length) {
      selectTopic(nextIdx);
    } else {
      setViewingAssignment(false);
    }
  };

  const selectedVideo =
  courseContent[selectedTopicIndex-1]?.videos?.[selectedVideoIndex]?.url ||
  courseContent[selectedTopicIndex-1]?.videos?.[0]?.url ||
  "";

  // Listen for fullscreen change events (e.g. user pressing Esc)
  useEffect(() => {
    const handleFsChange = () => {
      const fsEl = document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      setIsFullscreen(!!fsEl);
    };
    document.addEventListener("fullscreenchange", handleFsChange);
    document.addEventListener("webkitfullscreenchange", handleFsChange);
    document.addEventListener("mozfullscreenchange", handleFsChange);
    document.addEventListener("MSFullscreenChange", handleFsChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFsChange);
      document.removeEventListener("webkitfullscreenchange", handleFsChange);
      document.removeEventListener("mozfullscreenchange", handleFsChange);
      document.removeEventListener("MSFullscreenChange", handleFsChange);
    };
  }, []);

  const SuccessPopup = () => (
    <div className={`success-popup-overlay ${showSuccessPopup ? 'active' : ''}`}>
      <div className="success-popup-content">
        <div className="success-icon-wrapper">
          <div className="success-icon">✔</div>
        </div>
        <h2>{popupContent.title}</h2>
        <p className="success-message">{popupContent.message}</p>
        <p className="success-submessage">{popupContent.subMessage}</p>
        <div className="success-loader"></div>
      </div>
    </div>
  );

  const handleMarkAsDone = async () => {
  try {
    await handleProgressUpdate(100);

    alert("Topic marked as completed successfully.");
  } catch (error) {
    console.error("Error marking topic as completed:", error);
    alert("Failed to update progress.");
  }
};

  // Guard clause for undefined courseName (must be after all hooks)
  if (!courseName) {
    return <div>Course not found</div>;
  }

  return (
    <div className="border-style">
      <div className="blur-border-style"></div>
      <div className="dashboard__content">
        <div className="row extraSpace">
          <div className="col-lg-12 col-md-12">
            <div className="course-container">
              <div className="course-layout">
                <div className="course-sidebar">
                  <div className="cd-sidebar-header">
                    <h3 className="cd-title">{courseName}</h3>
                    <div className="cd-progress-labels">
                      <span>Overall Progress</span>
                    </div>
                    <div className="cd-progress-track">
                      <div className="cd-progress-fill" style={{ width: `${overallProgress}%` }} />
                    </div>
                  </div>

                  <div className="sidebar-scrollable">
                    <div className="topics-list">

                      {/* ── Interview Preparedness: grouped collapsible sidebar ── */}
                      {isInterviewPrep && (() => {
                        const groups = [
                          { name: "Understanding Yourself" },
                          { name: "Introduction to Communication" },
                          { name: "Self Introduction" },
                        ];
                        return groups.map((group, gIdx) => {
                          const subtopics = courseContent
                            .map((t, i) => ({ ...t, flatIndex: i+1 }))
                            .filter(t => t.groupIndex === gIdx);
                          const isGroupCollapsed = collapsedGroups[gIdx];
                          const groupDone = subtopics.every(t => (topicProgress[t.flatIndex] || 0) === 100);
                          const groupStarted = subtopics.some(t => (topicProgress[t.flatIndex] || 0) > 0);
                          return (
                            <div key={gIdx} className="ip-group-block">
                              <div
                                className={`ip-group-header ${groupDone ? 'group-done' : groupStarted ? 'group-started' : ''}`}
                                onClick={() => setCollapsedGroups(prev => ({ ...prev, [gIdx]: !prev[gIdx] }))}
                              >
                                <span className="ip-group-title">{group.name}</span>
                                <span className="ip-group-chevron">{isGroupCollapsed ? '▶' : '▼'}</span>
                              </div>
                              {!isGroupCollapsed && subtopics.map((t) => {
                                const progress = topicProgress[t.flatIndex] || 0;
                                const isLocked = getTopicLockedStatus(t.flatIndex);
                                const isActive = !viewingAssignment && selectedTopicIndex === t.flatIndex;
                                return (
                                  <div
                                    key={t.flatIndex}
                                    className={`ip-subtopic-block ${isLocked ? 'topic-locked' : ''} ${isActive ? 'topic-active' : ''}`}
                                    onClick={() => !isLocked && selectTopic(t.flatIndex)}
                                  >
                                    <div className="topic-info">
                                      <strong>
                                        {isLocked ? '🔒 ' : ''}
                                        {t.topic}
                                      </strong>
                                    </div>
                                    {!isLocked && (
                                      <div style={{ height: '6px', background: '#eee', borderRadius: '10px', overflow: 'hidden', margin: '4px 0 2px 0' }}>
                                        <div style={{ width: `${progress}%`, height: '100%', background: '#e49723ff', transition: 'width 0.4s ease' }} />
                                      </div>
                                    )}
                                    {t.videos.map((video, vi) => (
                                      <p key={vi} className={`video-link ${isActive ? 'active' : ''} ${isLocked ? 'disabled' : ''}`}>
                                        {video.title}
                                      </p>
                                    ))}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        });
                      })()}

                      {/* ── Existing courses: flat sidebar (unchanged) ── */}
                      {!isInterviewPrep && courseContent.map((t, index) => {
                         const topicIndex = index + 1;
                        const progress = topicProgress[topicIndex] || 0;
                        const isTopicLocked = getTopicLockedStatus(topicIndex);
                        const isActive = !viewingAssignment && selectedTopicIndex === topicIndex;

                        let assignments = [];
                        if (safeCourseName.toLowerCase() === "python") {
                          assignments = [
                            null, // Topic 0
                            { title: "Convert Distance", type: 'python1', completionKey: 'python1' },
                            { title: "Total & Average Marks", type: 'python2', completionKey: 'python2' },
                            { title: "Calculate Interest", type: 'python3', completionKey: 'python3' },
                            null, // Topic 4
                            { title: "Tuple", type: 'python4', completionKey: 'python4' },
                            { title: "Remove Dups", type: 'python5', completionKey: 'python5' },
                            { title: "Capitalize", type: 'python6', completionKey: 'python6' },
                            { title: "Conditional Capitalize", type: 'python7', completionKey: 'python7' },
                            { title: "Hypotenuse", type: 'python8', completionKey: 'python8' },
                            { title: "Student Roster", type: 'python9', completionKey: 'python9' },
                            { title: "Animal Counts", type: 'python10', completionKey: 'python10' },
                            { title: "Shape", type: 'python11', completionKey: 'python11' },
                          ];
                        } else if (safeCourseName.toLowerCase() === "sql") {
                          assignments = [
                            null, // Topic 0
                            { title: "Employee Table", type: 'employee_table', completionKey: 'sql1' },
                            { title: "Employee Data", type: 'employee_data', completionKey: 'sql2' },
                            { title: "Employee & Sales", type: 'employee_sales', completionKey: 'sql3' },
                            { title: "Customer Sales", type: 'customer_sales', completionKey: 'sql4' },
                            { title: "Student", type: 'student', completionKey: 'sql5' },
                            { title: "Customer Table", type: 'customer_table', completionKey: 'sql6' },
                            { title: "Sales, Customers & Orders", type: 'sales_customers_orders', completionKey: 'sql7' },
                            { title: "Customer Sub-queries", type: 'customer_sub_queries', completionKey: 'sql8' },
                            { title: "Banks", type: 'banks', completionKey: 'sql9' },
                            null, // Topic 10
                          ];
                        } else if (
                          safeCourseName.toLowerCase() === "java" ||
                          safeCourseName.toLowerCase() === "spring boot" ||
                          safeCourseName.toLowerCase() === "javascript & es6" ||
                          safeCourseName.toLowerCase() === "react" ||
                          safeCourseName.toLowerCase() === "java exceptions and algorithms" ||
                          safeCourseName.toLowerCase() === "data analysis" ||
                          safeCourseName.toLowerCase() === "nlp" ||
                          safeCourseName.toLowerCase() === "deep learning" ||
                          safeCourseName.toLowerCase() === "deeplearning"
                        ) {
                          // These courses have no assignments — all null to suppress assignment cards
                          assignments = Array(courseContent.length).fill(null);


                        } else {
                          assignments = [
                            null, // Topic 0
                            { title: "First HTML Page", type: 'html', completionKey: 'html' },
                            { title: "CSS Part 1", type: 'styling', completionKey: 'css1' },
                            { title: "CSS Part 2", type: 'styling2', completionKey: 'css2' },
                            { title: "Registration Forms", type: 'forms', completionKey: 'forms' },
                          ];
                        }

                        const topicAssignment = assignments[topicIndex - 1];
                        const isAssignmentCompleted = topicAssignment ? assignmentCompletion[topicAssignment.completionKey] : false;
                        const isAssignmentUnlocked = (progress === 100 || isAssignmentCompleted) && !isTopicLocked;

                        return (
                          <div
                            key={index}
                            className={`topic-block ${isTopicLocked ? "topic-locked" : ""} ${isActive ? "topic-active" : ""}`}
                            onClick={() => !isTopicLocked && selectTopic(topicIndex)}
                          >
                            <div className="topic-info">
                              <strong>
                                {isTopicLocked ? "🔒 " : (progress === 100 ? <span style={{ color: "#D26B15" }}>✔ </span> : "▶ ")}
                                {t.topic}
                              </strong>
                            </div>
                            {!isTopicLocked && (
                              <div style={{ height: "6px", background: "#eee", borderRadius: "10px", overflow: "hidden", margin: "6px 0" }}>
                                <div style={{ width: `${progress}%`, height: "100%", background: "#e49723ff", transition: "width 0.4s ease" }} />
                              </div>
                            )}
                          {t.videos.map((video, i) => (
  <p
    key={i}
    className={`video-link ${
      isActive && selectedVideoIndex === i ? "active" : ""
    } ${isTopicLocked ? "disabled" : ""}`}
    onClick={(e) => {
      e.stopPropagation();

      if (isTopicLocked) {
        return;
      }

      console.log("=================================");
      console.log("SUBTOPIC CLICKED");
      console.log("Topic Index:", topicIndex);
      console.log("Video Index:", i);
      console.log("Video Title:", video.title);
      console.log("Video URL:", video.url);
      console.log("=================================");

      setSelectedTopicIndex(topicIndex);
      setSelectedVideoIndex(i);
      setViewingAssignment(false);
    }}
    style={{
      cursor: isTopicLocked ? "not-allowed" : "pointer",
    }}
  >
    {video.title}
  </p>
))}

                            {topicAssignment && isAssignmentAllowed && (
                              safeCourseName.toLowerCase() !== "python" ||
                              true // Show all Python assignments in sidebar for clarity
                            ) && (
                                <div className="topic-assignment-section" onClick={(e) => e.stopPropagation()}>
                                  <div
                                    className={`assignment-action-card ${!isAssignmentUnlocked ? 'locked' : ''} ${isAssignmentCompleted ? 'completed' : ''} ${viewingAssignment && assignmentType === topicAssignment.type ? 'active' : ''}`}
                                    onClick={() => (isAssignmentUnlocked || isAssignmentCompleted) && handleAssignmentClick(topicAssignment.type, index)}
                                  >
                                    <div className="assignment-icon">
                                      {isAssignmentCompleted ? "✔" : "📝"}
                                    </div>
                                    <div className="assignment-info">
                                      <h4>{topicAssignment.title}</h4>
                                      <span className={`assignment-status ${isAssignmentCompleted ? 'completed' : ''}`}>
                                        {isAssignmentCompleted ? "Completed" : (!isAssignmentUnlocked ? "Locked (Complete topic first)" : "Try Assignment")}
                                      </span>
                                    </div>
                                    {isAssignmentUnlocked && !isAssignmentCompleted && (
                                      <div className="assignment-arrow">→</div>
                                    )}
                                  </div>
                                </div>
                              )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div
                  className="course-player"
                  ref={playerRef}
                  style={isFullscreen ? { display: "flex", flexDirection: "column", width: "100vw", height: "100vh", background: "#000", borderRadius: 0, padding: 0, margin: 0 } : {}}
                >
                  {!isFullscreen && (
                    <p
                      onClick={() => navigate("/applicant-lmscourses-list")}
                      style={{
                        color: "#f97316",
                        cursor: "pointer",
                        fontWeight: "600",
                        marginBottom: "12px",
                        fontSize: "16px",
                        transition: "color 0.2s ease, text-decoration 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "#ea580c";
                        e.target.style.textDecoration = "underline";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = "#f97316";
                        e.target.style.textDecoration = "none";
                      }}
                    >
                      ← Back
                    </p>
                  )}

                  {viewingAssignment && isAssignmentAllowed ? (
                    <div className="assignment-inline-view">
                      <AssignmentEditor
                        type={assignmentType}
                        onClose={handleCloseAssignment}
                        applicantId={applicantId}
                        assignmentType={assignmentType}
                        onNavigate={handleAssignmentNavigate}
                        onNextTopic={handleNextTopic}
                      />
                    </div>
                  ) : (
                    <div className="video-player-wrapper">
  {!isFullscreen && (
    <div className="immersive-overlay" onClick={toggleFullscreen}>
      <div className="overlay-msg">
        <span>⛶ Click anywhere to start Fullscreen Learning</span>
      </div>
    </div>
  )}

  <WorkingScormPlayer
    courseId={`${courseName}_${selectedTopicIndex}`}
    onProgressUpdate={handleProgressUpdate}
  />

{selectedVideo ? (
  <iframe
    key={`${courseName}_${selectedTopicIndex}_${selectedVideo}`}
    src={selectedVideo}
    className="video-frame"
    title="Course Player"
    allowFullScreen
    onLoad={(e) => {
      console.log("=================================");
      console.log("SCORM IFRAME LOADED");
      console.log("Selected Video:", selectedVideo);
      console.log("Iframe URL:", e.currentTarget.src);
      console.log("=================================");
    }}

    style={
      isFullscreen
        ? {
            width: "100%",
            height: "100%",
            border: "none",
            flex: 1,
          }
        : {}
    }
  />
): (
    <div
      className="video-frame"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#1B1B1B",
        color: "#fff",
        padding: "20px",
        textAlign: "center",
        border: "1px solid #333",
        borderRadius: "8px",
        boxSizing: "border-box",
        ...(isFullscreen
          ? {
              width: "100%",
              height: "100%",
              flex: 1,
              borderRadius: 0,
            }
          : {}),
      }}
    >
      <h3
        style={{
          color: "#e49723",
          marginBottom: "15px",
          fontSize: "24px",
        }}
      >
        {courseContent[selectedTopicIndex-1]?.topic}
      </h3>

      <p
        style={{
          maxWidth: "600px",
          fontSize: "16px",
          lineHeight: "1.6",
          color: "#ccc",
        }}
      >
        Welcome to the Final Project module! Please follow your curriculum
        guidelines to build your React.js frontend application. Once done,
        share your repository link with your mentor or upload your final
        submission.
      </p>
    </div>
  )}
{shouldShowMarkAsDone && (
    <div
        style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
            marginBottom: "5px",
            marginRight: "10px",
        }}
    >
        <button
            onClick={handleMarkAsDone}
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                backgroundColor: "#ffffff",
                color: "#000000",
                border: "1px solid #000000",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
                fontFamily: "inherit",
                gap: "4px",
                minWidth: "150px",
                height: "42px",
            }}
        >
            ☐ <span>Mark as Done</span>
        </button>
    </div>
)}
  <button
    onClick={toggleFullscreen}
    className="fullscreen-btn"
  >
    {isFullscreen ? "✕ Exit Fullscreen" : "⛶ Fullscreen"}
  </button>
</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessPopup />
    </div>
  );
};

export default CourseDetails;